{
	"AllTelServer": "[All Telephony Servers]",
	"AnyPartition": "[Any Partition]",
	"AnyDevices": "[Any Device]",
	"AnyAgents": "[Any ACD Agent]",
	"AnyAgentForDevice": "[Any At Set Device]",
	"AnyDeviceForAgent": "[Any With Set ACD Agent]",
	"DeviceValidation": "An administrator cannot have a device permission level set",
	"AgentValidation": "An administrator cannot have a agent permission level set",
	"EssentialsDeviceValidation": "An Essentials user must have a permission device set",
	"EssentialsDeviceValidation_MST": "A CXA Standard user must have a permission device set",
	"PermissionsLanguage_PermissionsNote": "Set user access level permissions.",
	"PermissionsLanguage_CmEnvironment": "CME:",
	"PermissionsLanguage_TelServer": "Telephony Server:",
	"PermissionsLanguage_Partition": "Partition:",
	"PermissionsLanguage_Device": "Group/Device:",
	"PermissionsLanguage_AndOrAgent": "Agent:",
	"PermissionsLanguage_SynchroniseSupervisorPermissions": "Sync Supervisor Permissions from Telephony Platform",
	"NAME": "PermissionsLanguage"
}